import {get} from './request'
import {Tenant, TenantVisitData} from "@/model/Tenant";

const proxyUrl = process.env.VUE_APP_BASE_URL + "/tenants"

export default {
    current: (): Promise<Tenant> => get(`${proxyUrl}/current`),
    visitData: (): Promise<TenantVisitData[]> => get(`${proxyUrl}/invite-data`),
}
